import React from "react";
import { Col, Grid, Row } from "react-bootstrap";
import Agents from "../components/settings/agents/Agents";
import DefaultWorkTimeSettings from "../components/settings/DefaultWorkTime";
import DeliverySettings from '../components/settings/Delivery';
import Departments from "../components/settings/departments/Departments";
import Schedule from "../components/settings/schedule/Schedule";
import WebsiteMeta from "../components/settings/WebsiteMeta";
import Employee from "../components/settings/employee/Employee";
import Popularity from "../components/settings/Popularity";
import TablesSettings from "../components/settings/TablesSettings";
import Faq from "../components/settings/faq/Faq";
import Reviews from "../components/settings/reviews/Reviews";
import PromoImage from "../components/settings/promo/PromoImage";
import News from "../components/settings/news/News";
import SmsLimit from "../components/settings/smslimit/SmsLimit";
import Document from "../components/settings/documents/Documents";

let Settings = (props) => (
    <Grid fluid={true}>
        <Row>
            <Col lg={3} md={6} sm={6} xs={12}>
                <DeliverySettings />
            </Col>
            <Col lg={3} md={6} sm={6} xs={12}>
                <DefaultWorkTimeSettings />
            </Col>
            <Col lg={4} md={8} sm={8} xs={12}>
                <Schedule />
            </Col>
            <Col lg={2} md={4} sm={4} xs={12}>
                <Popularity />
            </Col>
        </Row>
        <Row>
            <Col lg={6} md={12} sm={12} xs={12}>
                <Departments />
            </Col>
            <Col lg={6} md={12} sm={12} xs={12}>
                <Agents />
            </Col>
            <Col lg={6} md={12} sm={12} xs={12}>
                <Faq />
            </Col>
            <Col lg={6} md={12} sm={12} xs={12}>
                <Reviews />
            </Col>
        </Row>
        <Row>
            <Col lg={6} md={12} sm={12} xs={12}>
                <Employee />
            </Col>
            <Col lg={6} md={12} sm={12} xs={12} >
                <PromoImage />
            </Col>
            <Col lg={6} md={12} sm={12} xs={12}>
                <SmsLimit />
            </Col>
            <Col lg={6} md={12} sm={12} xs={12} >
                <News />
            </Col> 
            <Col lg={6} md={12} sm={12} xs={12} >
                <Document />
            </Col> 
        </Row>
        <Row>
            <Col lg={3} md={6} sm={6} xs={12}>
                <WebsiteMeta />
            </Col>
            <Col lg={3} md={3} sm={6} xs={12}>
                <TablesSettings />
            </Col>
            
        </Row>
    </Grid>);

export default Settings;


// WEBPACK FOOTER //
// ./src/containers/Settings.jsx